/* eslint-disable no-self-assign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import * as React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import { uploadFile } from "../../../../../../api/order";
import { useDispatch, useSelector } from "react-redux";
import { orderSelector } from "../../../../../../redux/slices/orderSlice";
import {
  getProductDetailsForUpdate,
  getRowIdWithImageUrl,
  getUploadedImageWithRowId,
  productSelector,
} from "../../../../../../redux/slices/productSlice";

export default function VariantsDataTable({ variants, applyToAllData }) {
  const { uploadedMediaFile } = useSelector(orderSelector);
  const { updateProductDetails } = useSelector(productSelector);
  const [fileLink, setFileLink] = React.useState(null);
  const { rowIdWithImageUrl, uploadedImageWithRowId } =
    useSelector(productSelector);

  //data table columns
  const columns = React.useMemo(
    () => [
      {
        field: "id",
        headerName: "Product",
        // editable:true,
        flex: 1,
        renderCell: (params) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "20px 0px",
              }}
            >
              <div
                style={{
                  marginRight: "20px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {params.row.img ? (
                  <img
                    src={params.row.img}
                    alt="product image"
                    style={{
                      borderRadius: "8px",
                      width: "50px",
                      height: "50px",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      border: "1px dashed lightgray",
                      width: "50px",
                      height: "50px",
                      borderRadius: "5px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton
                      onChange={(e) => {
                        setFileLink(e.target.files[0]);
                        //   setRowId(params.row.id)
                        dispatch(
                          getRowIdWithImageUrl({ rowId: params.row.id })
                        );
                      }}
                      //   color="primary"
                      aria-label="upload picture"
                      component="label"
                      // sx={{ position: "absolute", bottom: 10, right: 10 }}
                    >
                      <input hidden accept="image/*" type="file" />
                      <Icon icon="bi:cloud-upload" width="20" height="20" />
                    </IconButton>
                  </div>
                )}
              </div>
              <div>
                <h6 style={{ fontWeight: 500 }}>{params.row.title}</h6>
                <h6>{params.row.options.map((value) => value).join("/")}</h6>
              </div>
            </div>
          );
        },
      },
      {
        field: "sku",
        headerName: "SKU",
        flex: 1,
        editable: true,
        renderCell: (params) => {
          return (
            <div
              style={{
                width: "50%",
                padding: "8px 10px",
                background: "#f0f0f0",
                borderRadius: "5px",
              }}
            >
              {params.row.sku}
            </div>
          );
        },
      },
      {
        field: "price",
        headerName: "Product Cost",
        flex: 1,
        type: "number",
        editable: true,
        renderCell: (params) => {
          return (
            <div
              style={{
                width: "80px",
                padding: "8px 10px",
                background: "#f0f0f0",
                borderRadius: "5px",
              }}
            >
              €{params.row.price}
            </div>
          );
        },
      },
      {
        field: "weight",
        headerName: "Weight (Gr.)",
        type: "number",
        editable: true,
        renderCell: (params) => {
          return (
            <div
              style={{
                width: "80px",
                padding: "8px 10px",
                background: "#f0f0f0",
                borderRadius: "5px",
              }}
            >
              {params.row.weight}
            </div>
          );
        },
      },
    ],
    [variants?.length, uploadedMediaFile?.media, fileLink]
  );

  // const [row, setRow] = React.useState();

  const dispatch = useDispatch();

  // const [updatedVariantRows, setUpdatedVariantRows] = React.useState(variants);

  // get image with row id
  const getImageWithRowId = (row) => {
    const find = uploadedImageWithRowId?.find(
      (image) => image.rowId === row.rowId
    );

    if (!find) {
      dispatch(
        getUploadedImageWithRowId([
          ...uploadedImageWithRowId,
          { rowId: row?.rowId, img: row?.img },
        ])
      );
    }
  };

  // upload image if file link is found
  const uploadMedia = () => {
    const formData = new FormData();
    formData.append("media", fileLink);
    dispatch(uploadFile(formData));
    setFileLink(null);
  };

  React.useEffect(() => {
    if (fileLink) {
      uploadMedia();
    }
  }, [fileLink]);

  // if row id and image url is found then execute the below
  React.useEffect(() => {
    if (uploadedMediaFile?.media && rowIdWithImageUrl?.rowId) {
      dispatch(
        getRowIdWithImageUrl({
          ...rowIdWithImageUrl,
          img: uploadedMediaFile?.media,
        })
      );
    }
  }, [uploadedMediaFile?.media, rowIdWithImageUrl?.rowId]);

  React.useEffect(() => {
    getImageWithRowId({
      rowId: rowIdWithImageUrl?.rowId,
      img: uploadedMediaFile?.media,
    });
  }, [uploadedMediaFile?.media]);

  const [cellModifiedRow, setCellModifiedRow] = React.useState([]);

  const handleCellEditCommit = (params) => {
    const { id, field, value } = params;
    const manipulation = variants?.map((item) => {
      if (item.id === id) {
        item[field] = value;
      }
      return item;
    });
    setCellModifiedRow(manipulation);
  };


  //merge array to render on table
  const getMergedArray = (array1, array2, imageArray) => {
    const mergeArray = [];

    array1.forEach((item1) => {
      const found = array2.find((item2) => item2.id === item1.id);
      const foundImage = imageArray.find((image) => image.rowId === item1.id);
      if (found && foundImage) {
        mergeArray.push({
          ...found,
          price: found?.price,
          weight: found?.weight,
          options: item1.options,
          sku: found?.sku || item1.sku,
          img: foundImage?.img,
        });
      } else {
        mergeArray.push(item1);
      }
    });
    return mergeArray;
  };

  const mergedVariants = getMergedArray(
    variants,
    cellModifiedRow,
    uploadedImageWithRowId
  );

  const mergedVariantWithImage =
    uploadedImageWithRowId?.length > 0 &&
    mergedVariants?.map((mergeVariant, i) => {
      const findImage = uploadedImageWithRowId?.find(
        (uploadedImage) => uploadedImage?.rowId === mergeVariant.id
      );
      if (findImage) {
        return {
          ...mergeVariant,
          img: findImage.img,
        };
      } else {
        return mergeVariant;
      }
    });

  const manipulateWithCellEditRow = () => {
    return (
      mergedVariantWithImage?.length > 0 &&
      mergedVariantWithImage?.map((mergeVariant) => {
        const findCellRow = cellModifiedRow.find(
          (cellRow) => cellRow.id === mergeVariant.id
        );

        if (findCellRow) {
          return {
            ...mergeVariant,
            price: findCellRow.price,
            weight: findCellRow.weight,
            sku: findCellRow.sku,
          };
        } else {
          return mergeVariant;
        }
      })
    );
  };

  const normalizeVariants = manipulateWithCellEditRow();

  const manipulateWithSavedVariants = () => {
    const savedVariants = updateProductDetails?.variants?.length > 0;
    if (savedVariants) {
      return (
        normalizeVariants?.length > 0 &&
        normalizeVariants?.map((finalVariant) => {
          // const cell = cellModifiedRow?.find((cellItem) => cellItem.id === finalVariant.id)
          const find = updateProductDetails?.variants?.find(
            (variant) => variant.id === finalVariant.id
          );
          if (find) {
            return {
              ...find,
              img: finalVariant.img,
              sku: finalVariant?.sku || find?.sku,
              price: finalVariant?.price || find?.price,
              weight: finalVariant?.weight || find?.weight,
            };
          } else {
            return finalVariant;
          }
        })
      );
    } else {
      return normalizeVariants;
    }
  };

  const finalVariants = manipulateWithSavedVariants();

  const mergeFinalVariantsWithApplyToAll =
    finalVariants?.length > 0 &&
    finalVariants?.map((final, i) => {
      const allData = applyToAllData?.length > 0;

      if (allData) {
        const find = applyToAllData[i];
        return {
          ...final,
          price: final?.price || find?.price || 0,
          weight: final?.weight || find?.weight || 0,
        };
      } else {
        return final;
      }
    });

  React.useEffect(() => {
    dispatch(
      getProductDetailsForUpdate({
        ...updateProductDetails,
        variants: mergeFinalVariantsWithApplyToAll,
      })
    );
  }, [
    dispatch,

    mergedVariants?.length,
    uploadedImageWithRowId?.length,
    variants?.length,
    rowIdWithImageUrl,
    applyToAllData,
    cellModifiedRow,
  ]);

  return (
    <Box
      sx={{
        height: variants?.length > 0 ? "600px" : "400px",
        width: "100%",
        marginTop: "20px",
        // padding: "0px 10px",
      }}
    >
      <DataGrid
        rowHeight={63}
        checkboxSelection={false}
        sx={{
          ".MuiDataGrid-columnSeparator": {
            display: "none",
          },
          ".MuiDataGrid-columnHeaders": {
            backgroundColor: "#f9f9f9",
          },
          "&.MuiDataGrid-root": {
            border: "1px solid #eee",
            // borderRadius: "12px",
            // boxShadow: "1px 1px 1px 2px gray"
          },
          "& .MuiDataGrid-virtualScroller": {
            overflow: "auto",
            width: "5px",
          },
          ".MuiDataGrid-footerContainer": {
            display: "none",
          },
          ".MuiDataGrid-row": {
            backgroundColor: "#ffffff",
            borderBottom: "3px soliod gray",
          },
          ".MuiDataGrid-row--editing": {
            boxShadow: "none",
          },
        }}
        rows={
          finalVariants?.length > 0
            ? mergeFinalVariantsWithApplyToAll || updateProductDetails?.variants
            : mergedVariants || variants
        }
        // key={row?.id}
        getRowId={(row) => row?.id || row?._id}
        columns={columns}
        pageSize={20}
        rowsPerPageOptions={[20]}
        // disableSelectionOnClick
        showCellBottomtBorder={false}
        // editMode="row"
        hideFooterPagination={true}
        // experimentalFeatures={{ newEditingApi: true }}
        onCellEditCommit={handleCellEditCommit}
      />
    </Box>
  );
}
